import React from "react";
import { ComponentGrid } from "../components/Grid/ComponentGrid";
import { Layout } from "../components/Layout";
import { Main } from "../components/Main";
import "../scss/index.scss";

const Index = () => {
    return (
        <Layout>
            <Main path={"/*"}>
                <ComponentGrid />
            </Main>
        </Layout>
    );
};

export default Index;
